import { prepareZXingModule } from "zxing-wasm/writer";
import wasmUrl from "zxing-wasm/writer/zxing_writer.wasm?url";

// Our build, not the jsDelivr default: plant may have no internet.
prepareZXingModule({
	overrides: {
		locateFile: (path: string, prefix: string) =>
			path.endsWith(".wasm") ? wasmUrl : prefix + path,
	},
});

export { writeBarcode } from "zxing-wasm/writer";
